import React from 'react';
import { formatCurrency } from '../utils/dateUtils.ts';
import './FinancialIndependenceIndicators.css';

interface FIIndicator {
  required_capital: number;
  expense_coverage_ratio: number;
  calculation_date: string;
}

interface FinancialIndependenceIndicatorsProps {
  indicator: FIIndicator | null;
}

const FinancialIndependenceIndicators: React.FC<FinancialIndependenceIndicatorsProps> = ({ indicator }) => {
  if (!indicator) {
    return (
      <div className="fi-empty">
        Nenhum indicador de independência financeira calculado.
      </div>
    );
  }

  return (
    <div className="fi-container">
      <div className="fi-card">
        <span>Capital necessário</span>
        <strong>{formatCurrency(indicator.required_capital)}</strong>
      </div>
      <div className="fi-card">
        <span>Índice de cobertura</span>
        <strong>{(indicator.expense_coverage_ratio * 100).toFixed(1)}%</strong>
      </div>
      <div className="fi-note">
        Calculado em: {indicator.calculation_date?.split('T')[0]}
      </div>
    </div>
  );
};

export default FinancialIndependenceIndicators;
